// import node module libraries
import { v4 as uuid } from "uuid";
import { TextSearch, MessageSquare, LayoutGrid, Settings } from "lucide-react";

export const dbConnectionList = [
  {
    id: uuid(),
    title: "PostgreSQL",
    desc: "Reliable, open-source relational database system",
    logo: "/postgresql.svg",
    isActive: true,
    connectionName: "postgre-connection",
    db_type: "PostgreSQL",
  },
  {
    id: uuid(),
    title: "MySQL",
    desc: "Popular SQL database for scalable applications",
    logo: "/mysql.svg",
    isActive: true,
    connectionName: "mysql-connection",
    db_type: "MySQL",
  },
  {
    id: uuid(),
    title: "AWS RedShift",
    desc: "Fast, fully managed data warehouse on AWS",
    logo: "/aws-redshift.svg",
    isActive: true,
    connectionName: "aws-redshift-connection",
    db_type: "Redshift",
  },
  {
    id: uuid(),
    title: "Excel, CSV",
    desc: "Easily import data from spreadsheets & CSV files",
    logo: "/googlesheet.svg",
    isActive: true,
    connectionName: "excel-connection",
    db_type: "Excel, CSV",
  },
];

export const chatSidebarLinks = [
  {
    id: uuid(),
    title: "Chatbot",
    link: "/chatbot",
    icon: <MessageSquare />,
  },

  {
    id: uuid(),
    title: "Dashboard",
    link: "/dashboard",
    icon: <LayoutGrid />,
  },
  // {
  //   id: uuid(),
  //   title: "Settings",
  //   link: "/settings",
  //   icon: <Settings />,
  // },
];
